// FIXME: must export from ui-library
export enum SnackbarStatusEnum {
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  DEFAULT = 'default',
  WHITE = 'white',
}

export enum SnackbarsShowEvents {
  DEFAULT = 'show-snackbar-notification',
}
